// Intentional Pinia store — persists the active theme preset to localStorage. No API calls.
import { defineStore } from "pinia";

interface ThemeState {
  activePresetId: string;
}

export const useThemeStore = defineStore({
  id: "theme",
  persist: true,

  state: (): ThemeState => ({
    activePresetId: "default",
  }),

  actions: {
    setActivePreset(presetId: string) {
      this.activePresetId = presetId;
    },
  },
});
